import { sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackTrustCarouselImpression = (visibleHeadingText: string) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: 'PDP Trust Carousel',
    event_label: 'We are... Not On The High Street',
    event_name: 'view_content',
    content_type: 'trust carousel',
    item_id: 'We are... Not On The High Street',
    visible_carousel_components: visibleHeadingText,
  });
};
